import { PaymentServiceAccountStatus } from "@src/lib/interface";

export const ShouldBeOnboardedStatuses = [
  PaymentServiceAccountStatus.ACCOUNT_CREATED,
  PaymentServiceAccountStatus.ACCOUNT_NEEDS_UPDATE,
  PaymentServiceAccountStatus.INSTANT_PAYOUT_PENDING,
  PaymentServiceAccountStatus.STANDARD_PAYOUT_PENDING,
];
